import { toast } from 'react-toastify';

/** How long the toast stays up before react-toastify dismisses it. */
const TOAST_AUTO_CLOSE_MS = 5000;

/**
 * How long the expiry notice stays on screen before the caller redirects.
 *
 * Without a pause the navigation wins the race against the first paint: the
 * user lands on the login screen with no explanation of why they left the
 * screen they were on. Derived from the toast's own lifetime so the two cannot
 * drift apart — redirect a beat early, while the message is still up, rather
 * than after it has already dismissed itself and left a blank screen.
 */
const NOTICE_DURATION_MS = TOAST_AUTO_CLOSE_MS - 500;

/**
 * Tells the user their session ended underneath them, and resolves once the
 * message has had time to be read.
 *
 * The toast renders in the ToastContainer that Layout mounts. In an app without
 * a container the call is inert and only the delay is felt, which degrades to a
 * slow redirect rather than an error.
 */
export function notifySessionExpired(message?: string): Promise<void> {
  toast.error(
    message || 'Your session has expired. You will be redirected to login.',
    {
      position: 'top-center',
      autoClose: TOAST_AUTO_CLOSE_MS,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    },
  );

  return new Promise(resolve => {
    setTimeout(resolve, NOTICE_DURATION_MS);
  });
}
